import React, { Component } from 'react';
import { Linking, Platform } from 'react-native';

import { get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { openInStore, openApp } from '../../services/DeepLinking';
import List from '../List';

import styles from './ConnectedApps.styles';

class ConnectedApps extends Component {
  state = {
    apps: {},
  };

  storeByOs = {
    ios: {
      eBiznes: "https://apps.apple.com/gb/app/ebiznes-nga-vodafone/id1549214222",
      'Smart Fleet': "https://apps.apple.com/al/app/vodafone-albania-smart-fleet/id1577964943",
      'Tag & track': "https://apps.apple.com/gb/app/vodafone-business-tag-track/id1477489342",
      'Temperature Tag': "https://apps.apple.com/gb/app/vodafone-temperature-tag/id1529108283",
      Juth: 'https://apps.apple.com/us/app/juth/id1450384517',
      "Tirana Ime": 'https://apps.apple.com/us/app/tirana-ime-2-0/id1082751161',
      "Bright Sky": null
    },
    android: {
      eBiznes: "https://play.google.com/store/apps/details?id=com.ebiznes",
      'Smart Fleet': "https://play.google.com/store/apps/details?id=com.vodafoneinnovus.smartfleet",
      'Tag & track': "https://play.google.com/store/apps/details?id=com.trackimo.tagandtrack",
      'Temperature Tag': "https://play.google.com/store/apps/details?id=com.vodafoneinnovus.coolio",
      Juth: 'https://play.google.com/store/apps/details?id=com.vodafone.juthal',
      "Tirana Ime": 'https://play.google.com/store/apps/details?id=ch.arkit.TiranaMobility',
      "Bright Sky": 'https://play.google.com/store/apps/details?id=com.vodafone.brightsky.al'
    }
  }

  componentDidMount() {
    const { onRefreshConnectedApps } = this.props;
    this.onRefresh();
    onRefreshConnectedApps(() => this.onRefresh());
  }

  onRefresh = () => {
    this.prepareItems(this.props.items).then(items => this.setState({ apps: items }));
  };

  prepareItems(items) {
    const promises = items.map(async item => {
      const url = _get(item, ['extraInfo', 'url', Platform.OS], undefined);
      return {
        ...item,
        isInstalled: false,
      };
    });
    return Promise.all(promises);
  }

  check_iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  formatItems(items, theme) {
    const result = items.map((item, index) => {
      const url = _get(item, ['extraInfo', 'url', Platform.OS], undefined);
      item.textStyle = styles.title(theme);
      item.isClickable = false;
      item.leftIconType = IconTypes.image;
      item.leftIconSize = 36;
      item.containerStyle =
        index === items.length - 1
          ? [styles.listItemContainerStyle(theme), styles.lastListItemContainerStyle]
          : styles.listItemContainerStyle(theme);
      if (!item.isInstalled) {
        item.buttonText = 'dashboard_app_get_action_label';
        item.onPress = () => {
          if (this.check_iOS()) {
            if (this.storeByOs.ios[item.name]) {
              window.open(this.storeByOs.ios[item.name], '_blank')
            }
          } else {
            if (this.storeByOs.android[item.name]) {
              window.open(this.storeByOs.android[item.name], '_blank')
            }
          }
        };
        item.itemAccessibilityLabel = FrameworkTestKeys.ConnectedAppsItem;
        item.itemButtonAccessibilityLabel = FrameworkTestKeys.ConnectedAppsButton;
        item.itemIconAccessibilityLabel = FrameworkTestKeys.ConnectedAppsIcon;
        item.itemTitleAccessibilityLabel = FrameworkTestKeys.ConnectedAppsTitle;
        item.buttonType = 'primary';
        item.buttonStyle = styles.getButton;
        item.buttonTextStyle = styles.getButtonText;
        item.blackTint = false
      } else {
        item.buttonText = 'dashboard_app_open_action_label';
        item.onPress = () => {
          if (this.check_iOS()) {
            if (this.storeByOs.ios[item.name]) {
              window.open(this.storeByOs.ios[item.name], '_blank')
            }
          } else {
            if (this.storeByOs.android[item.name]) {
              window.open(this.storeByOs.android[item.name], '_blank')
            }
          }
        }
        item.buttonType = 'secondary';
        item.buttonStyle = styles.openButton(theme);
        item.buttonTextStyle = styles.openButtonText(theme);
        item.blackTint = false
      }
      return item;
    });
    return result;
  }

  render() {
    const { apps } = this.state;
    const {
      title,
      moreText,
      lessText,
      images,
      viewAccessibilityLabel,
      listTitleAccessibilityLabel,
      itemsAccessibilityLabel,
      itemName,
      theme,
    } = this.props;
    let formattedApps = {};
    if (apps && apps.length > 0) {
      formattedApps = this.formatItems(apps, theme);
    }
    if (formattedApps.length > 0) {
      return (
        <List
          items={formattedApps}
          title={title}
          moreText={moreText}
          lessText={lessText}
          style={styles.listStyle}
          headerContainerStyle={styles.headerContainerStyle}
          itemsContainerStyle={styles.itemsContainerStyle(theme)}
          images={images}
          viewAccessibilityLabel={viewAccessibilityLabel}
          itemsAccessibilityLabel={itemsAccessibilityLabel}
          listTitleAccessibilityLabel={listTitleAccessibilityLabel}
          itemName={itemName}
        />
      );
    }
    return null;
  }
}

ConnectedApps.defaultProps = {
  onRefreshConnectedApps: () => { },
  theme: LightThemeColors,
};

ConnectedApps.propTypes = {
  title: PropTypes.any.isRequired,
  items: PropTypes.any.isRequired,
  onRefreshConnectedApps: PropTypes.func,
  viewAccessibilityLabel: PropTypes.string,
  listTitleAccessibilityLabel: PropTypes.string,
  itemsAccessibilityLabel: PropTypes.string,
  itemName: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  images: PropTypes.object,
  moreText: PropTypes.string,
  lessText: PropTypes.string,
};

export default withTheme(ConnectedApps);
